export const multiplyVector = (p, ratio) => ({
    x: p.x * ratio,
    y: p.y * ratio,
});

export const multiplyVector2 = (p, v2) => ({
    x: p.x * v2.x,
    y: p.y * v2.y,
});
